import React from 'react';
import { krdetailConstants } from './../../../constants/krdetails.constants';
import { kpiMarketplaceConstants } from './../../../constants/kpiMarketplace.constants';
import GoalServices from './../../../services/goal.services';
import { withTranslation } from 'react-i18next';
import { getExternalAppIconDataUri, isKpiIframeMetricTargetApp } from './../../../utils/kpi-market-place-util';
import { openViewKpiModal } from './../../../apps/kpis/utils';
import { KPI_LOCATION_VALUES } from './../../../apps/kpis/constants';
import ExternalKpiDataSource from './externalKpiDataSource';

class KpiDataSourceComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleLinkClicks = this.handleLinkClicks.bind(this);
  }

  handleLinkClicks(url, pageRef, metricId) {
    window.open(url, '_blank');
    if (pageRef != '' && metricId) {
      let goalServices = new GoalServices();
      goalServices.firePushAnalyticsData({ krId: metricId, pageRef: pageRef });
    }
  }

  getProjectsElement(appId, dataSource) {
    let url = this.props.dataSource.url;
    appId = parseInt(appId);
    if (appId == krdetailConstants.WOBO_KPI_ID) {
      return <span>{dataSource.data.name}</span>;
    }
    return dataSource.projects.map((project) => {
      const displayName = project.name.split(':');
      return (
        <span
          key={project.id}
          className="sourceName externalType"
          onClick={(e) => this.handleLinkClicks(url, 'krpage_salesforce', this.props.metricId)}
        >
          {displayName[1] || ''}
        </span>
      );
    });
  }
  getExAppIcon(appId) {
    appId = parseInt(appId);
    return kpiMarketplaceConstants.WOBO_EXT_APP_LOGO_MAP.has(appId)
      ? kpiMarketplaceConstants.WOBO_EXT_APP_LOGO_MAP.get(appId)
      : '';
  }

  getExternalAppIconDataUri(app_id) {
    return getExternalAppIconDataUri(app_id);
  }

  getSelectionDetail(appId, data) {
    appId = parseInt(appId);
    switch (appId) {
      case krdetailConstants.WOBO_KPI_ID:
        return null; //<span>{data?.description}</span>; // TODO: display team here?
      case krdetailConstants.SALESFORCE_APP_ID:
        return (
          <span>
            {data?.label} | {data?.groupName}
          </span>
        );
      case krdetailConstants.RALLY_APP_ID:
        // this is because of backward compatibility we original search by name, then change to id.
        if (!data.featureFormattedIDs && !data.featureLaunchUrls) {
          return <span></span>;
        }

        const details = [];
        const featureIds = data.featureFormattedIDs ? data.featureFormattedIDs.split(',') : [];
        const featureNames = data.featureQueries ? data.featureQueries.split('::') : [];
        const featureLaunchUrls = data.featureLaunchUrls ? data.featureLaunchUrls.split(',') : [];
        for (let i = 0; i < featureNames.length; i++) {
          details.push(
            <span
              key={featureNames[i]}
              className="sourceName externalType"
              onClick={(e) => this.handleLinkClicks(featureLaunchUrls[i], 'krpage_salesforce', this.props.metricId)}
            >
              {featureIds[i] ? featureIds[i] + ': ' : ''} {featureNames[i]}
            </span>,
          );
        }

        return (
          <span className="salesforceSelectedReport">
            <span>{data?.featureType} - </span>
            {details &&
              details.map((item, index) => (
                <span key={index}>
                  {index ? ', ' : ''} {item}
                </span>
              ))}
          </span>
        );

      case krdetailConstants.JIRA_KPI_ID:
        if (data?.selectedType == 'advancedJQL') {
          const url = new URL(data?.webUrl || '');
          const finalResult = url?.href.replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/&/g, '%26');
          return (
            <span className="salesforceSelectedReport">
              <span>JQL - </span>
              <span
                key="advancedJQL"
                className="sourceName externalType"
                onClick={(e) => this.handleLinkClicks(finalResult, 'krpage_salesforce', this.props.metricId)}
              >
                {data.projectName}
              </span>
            </span>
          );
        } else if (data?.selectedType == 'epicJQL') {
          const details = [];
          const epicIds = data?.filters.epicIds || [];
          const webUrls = data.webUrl ? data.webUrl.split(',') : [];
          for (let i = 0; i < epicIds.length; i++) {
            details.push(
              <span
                key={epicIds[i]}
                className="sourceName externalType"
                onClick={(e) => this.handleLinkClicks(webUrls[i], 'krpage_salesforce', this.props.metricId)}
              >
                {epicIds[i]}
              </span>,
            );
          }
          return (
            <span className="salesforceSelectedReport">
              <span>Epic(s) - </span>
              {details &&
                details.map((item, index) => (
                  <span key={index}>
                    {index ? ', ' : ''} {item}
                  </span>
                ))}
            </span>
          );
        } else {
          const details = [];
          const projectIds = data?.filters?.projectIds || [];
          const projectNames = data.projectName ? data.projectName.split('::') : [];
          const webUrls = data.webUrl ? data.webUrl.split(',') : [];
          for (let i = 0; i < projectNames.length; i++) {
            details.push(
              <span
                key={projectNames[i]}
                className="sourceName externalType"
                onClick={(e) => this.handleLinkClicks(webUrls[i], 'krpage_salesforce', this.props.metricId)}
              >
                {projectIds[i] ? projectIds[i] + ': ' : ''} {projectNames[i]}
              </span>,
            );
          }

          return (
            <span className="salesforceSelectedReport">
              <span>Project(s) - </span>
              {details &&
                details.map((item, index) => (
                  <span key={index}>
                    {index ? ', ' : ''} {item}
                  </span>
                ))}
            </span>
          );
        }
      case krdetailConstants.AZURE_DEVOPS_KPI_ID: {
        // Field shape comes from the app-services connector, not this repo.
        const { t } = this.props;
        const adoExtra = this.props.dataSource?.kpiData?.externalObjectExtra || data || {};
        const project = adoExtra.project || {};
        const queryMethod = adoExtra.queryMethod || adoExtra.issueMode;
        const projectUrl = project.url
          ? project.url.replace('/_apis/projects/', '/')
          : '';

        if (queryMethod === 'savedQuery') {
          const sq = adoExtra.savedQuery || {};
          const queryLabel =
            adoExtra.queryCustomName || sq.name || adoExtra.queryName || project.name;
          const queryUrl = adoExtra.queryUrl
            || (projectUrl && (sq.id || adoExtra.savedQueryId)
                  ? `${projectUrl}/_queries/query/${sq.id || adoExtra.savedQueryId}/`
                  : '');
          if (!queryLabel) return <span></span>;
          return (
            <span className="salesforceSelectedReport">
              <span>{t('Query')} - </span>
              <span
                className="sourceName externalType"
                onClick={() => this.handleLinkClicks(queryUrl, 'krpage_azure_devops', this.props.metricId)}
              >
                {queryLabel}
              </span>
            </span>
          );
        }

        // workitems mode (queryMethod === 'workitems') — render selected items
        const workItems = Array.isArray(adoExtra.selectedWorkItems) && adoExtra.selectedWorkItems.length
          ? adoExtra.selectedWorkItems
          : (Array.isArray(adoExtra.workItems) ? adoExtra.workItems : []);
        if (workItems.length === 0) return <span></span>;
        const details = workItems.map((wi) => {
          const id = wi.id || wi.workItemId;
          const title = wi.title || wi.name || '';
          const url = wi.url || wi.workItemUrl
            || (projectUrl && id ? `${projectUrl}/_workitems/edit/${id}` : '');
          return (
            <span
              key={id || title}
              className="sourceName externalType"
              onClick={() => this.handleLinkClicks(url, 'krpage_azure_devops', this.props.metricId)}
            >
              {id ? id + ': ' : ''}{title}
            </span>
          );
        });
        return (
          <span className="salesforceSelectedReport">
            <span>{t('Work item(s)')} - </span>
            {details.map((item, index) => (
              <span key={index}>
                {index ? ', ' : ''} {item}
              </span>
            ))}
          </span>
        );
      }
      case krdetailConstants.GITLAB_ID:
        const kpiData = this.props.dataSource.kpiData;
        if (kpiData) {
          data = kpiData.externalObjectExtra;
        }
        if (data.selectedType === 'epicProgress') {
          return (
            <span className="salesforceSelectedReport">
              <span>Epic: </span>
              <span
                className="sourceName externalType"
                onClick={(e) => this.handleLinkClicks(data.selectedEpic.web_url, 'krpage_gitlab', this.props.metricId)}
              >
                {data.selectedEpic.name || data.selectedEpic.title}
              </span>
            </span>
          );
        }
        return <span></span>;
      default:
        return <span></span>;
    }
  }

  render() {
    const { t, dataSource, data, metricId, offsetUpdateValue } = this.props;
    const extAppIcon = this.getExAppIcon(dataSource.app_id);
    const extAppDataUri = this.getExternalAppIconDataUri(dataSource.app_id);
    const projects = this.getProjectsElement(dataSource.app_id, dataSource);
    const projectsSelectionDetail = this.getSelectionDetail(dataSource.app_id, data, metricId);
    const isOffsetUpdateEnabled = window.wbConfig.isOffsetUpdateEnabled ?? false;
    const showOffsetUpdate = isOffsetUpdateEnabled && offsetUpdateValue;
    let displayPercent;
    let value = 0;
    let total = 0;
    if (
      isKpiIframeMetricTargetApp(Number(dataSource.app_id)) &&
      data.dataType === 'percent' &&
      this.props.achieveTarget
    ) {
      value = this.props.dataSource.kpiData?.data?.value ?? this.props.data.value ?? 0;
      total = this.props.dataSource.kpiData?.data?.total ?? 0;
      const percentValue = total > 0 ? (value / total) * 100 : null;
      displayPercent =
        percentValue != null ? (Number.isInteger(percentValue) ? percentValue : percentValue.toFixed(2)) : undefined;
    }
    const isWoboKpi = Number(dataSource.app_id) == krdetailConstants.WOBO_KPI_ID;
    const woboKpiId = dataSource?.kpiId;

    return (
      <>
        {this.props.showIcon && (
          <>
            {extAppIcon && <div className={'krTypeIcon verticalMidle sourceIcon ' + extAppIcon}></div>}
            {!extAppIcon && extAppDataUri && (
              <div className="krTypeIcon verticalMidle sourceIcon">
                <img src={extAppDataUri} style={{ width: '24px' }} />
              </div>
            )}
            <div className="verticalMidle streamTypeBlk">
              <span className="sourceType">Sourcing from </span>
            </div>
            <br />
          </>
        )}

        <div
          className="salesforceSelectedExternalSources salesforceSelectedWrapper verticalTop"
          style={{
            display: 'inline-block',
            minWidth: '51%',
            cursor: isWoboKpi && woboKpiId ? 'pointer' : 'default',
          }}
          onClick={() => {
            if (isWoboKpi && woboKpiId) {
              openViewKpiModal(woboKpiId, KPI_LOCATION_VALUES.OKR_PAGE_TRAY);
            }
          }}
        >
          <div className="salesforceSelectedReport">{projects}</div>
          <div className="salesforceSelectedReport">{projectsSelectionDetail}</div>
          {isKpiIframeMetricTargetApp(Number(dataSource.app_id)) &&
          data.dataType === 'percent' &&
          displayPercent !== undefined ? (
            <div className="salesforceSelectedValue" title="">
              {t('Last Value') + ':'} {value} {'of'} {total} {' - ' + displayPercent + '%'}
            </div>
          ) : isWoboKpi ? (
            <ExternalKpiDataSource kpiId={woboKpiId} />
          ) : (
            <div className="salesforceSelectedValue" title="">
              {t('Last Value') + ':'} {this.props.achieveTarget}
            </div>
          )}
          {showOffsetUpdate && (
            <div
              className="salesforceSelectedValue"
              title=""
            >{`${t('Offset update')} : ${offsetUpdateValue} day(s)`}</div>
          )}
        </div>
      </>
    );
  }
}

export default withTranslation()(KpiDataSourceComponent);
